import { BACKEND_CREATE_EVENT } from '@perpay-web/fintech/constants/actionTypes';

export function createEvent(eventType) {
    return {
        type: BACKEND_CREATE_EVENT,
        payload: {
            eventType,
        },
    };
}
